const FAQActionTypes = {
    FAQ_GET_DATA_LOAD:'FAQ_GET_DATA_LOAD',
    FAQ_GET_DATA_SUCCESS:'FAQ_GET_DATA_SUCCESS',
    FAQ_GET_DATA_FAILURE:'FAQ_GET_DATA_FAILURE',
    };
    export default FAQActionTypes;